export default __webpack_public_path__ + "static/media/cancel_discount.a5404f81.png";